import React, { useState, useEffect } from "react";
let process = {
  env: {}
};
const Refer = _ref => {
  let {
    navigate
  } = _ref;
  const [isSharing, setIsSharing] = useState(false);
  // let memberData = JSON.parse(localStorage.getItem('memberData'));
  let memberId = "";
  if (localStorage.getItem("memberId")) {
    memberId = localStorage.getItem("memberId");
  }
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  useEffect(() => {
    scrollToTop();
  }, []);
  const [copySuccess, setCopySuccess] = useState(false);
  const handleShare = async () => {
    if (isSharing) return;
    setIsSharing(true);
    const shareText = "Hi there! You\u2019re invited to join the BLR Airport App. Download it using the link below and sign up to receive 100 bonus points instantly! Unlock exclusive rewards and enjoy a seamless airport experience. Don\u2019t miss out\u2014download now!\n\nClick here to download: https://dev-gm.bengaluruairport.com/signup?enrollment_referrer=".concat(memberId, "&enrolment_source=lmsgravtyreferral\n\nCheers,\nTeam BLR Pulse powered by Gray Matter");
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Check this out!",
          text: shareText
        });
      } catch (error) {
        console.log("Error sharing:", error);
      } finally {
        setIsSharing(false);
      }
    } else {
      try {
        await navigator.clipboard.writeText(shareText);
        setCopySuccess(true); // Show success message
        setTimeout(() => setCopySuccess(false), 5000);
      } catch (error) {
        console.log("Error copying to clipboard:", error);
      } finally {
        setIsSharing(false);
      }
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "refer-container"
  }, copySuccess && /*#__PURE__*/React.createElement("div", {
    className: "copy-notification"
  }, "Your referral link has been copied! Share it with your friends and get referral bonus points. T&C applied"), /*#__PURE__*/React.createElement("div", {
    className: "heading"
  }, "Earn with ", /*#__PURE__*/React.createElement("span", {
    className: "heading-inside"
  }, "every referral")), /*#__PURE__*/React.createElement("div", {
    className: "sub-heading"
  }, "Invite friends to the", " ", /*#__PURE__*/React.createElement("span", {
    className: "sub-heading-inside"
  }, "Pulse Rewards and earn points")), /*#__PURE__*/React.createElement("div", {
    className: "bullet-points"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bullet"
  }, /*#__PURE__*/React.createElement("img", {
    className: "bullet-image",
    src: "https://d3hc1c528irei0.cloudfront.net/ui/ReferralBullet/BulletOne.png"
  }), " ", "Invite friends to Pulse Rewards"), /*#__PURE__*/React.createElement("div", {
    className: "bullet"
  }, /*#__PURE__*/React.createElement("img", {
    className: "bullet-image",
    src: "https://d3hc1c528irei0.cloudfront.net/ui/ReferralBullet/BulletTwo.png"
  }), " ", "They make a transaction on Pulse"), /*#__PURE__*/React.createElement("div", {
    className: "bullet"
  }, /*#__PURE__*/React.createElement("img", {
    className: "bullet-image",
    src: "https://d3hc1c528irei0.cloudfront.net/ui/ReferralBullet/BulletThree.png"
  }), " ", /*#__PURE__*/React.createElement("div", null, "You and your friend receive", " ", /*#__PURE__*/React.createElement("img", {
    src: "https://d3hc1c528irei0.cloudfront.net/ui/PulseCoin.png",
    alt: "",
    style: {
      marginBottom: "3px",
      height: "15px"
    }
  }), "100 reward points"))), /*#__PURE__*/React.createElement("div", {
    className: "invite",
    style: {
      marginLeft: "8px"
    }
  }, /*#__PURE__*/React.createElement("button", null, /*#__PURE__*/React.createElement("div", {
    onClick: handleShare
  }, "Invite Friends"))));
};
export { Refer };